import { BaseIcon, BaseIconProps } from "@/shared/icons/BaseIcon";

export function TorsosIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M1.49342 23.5729C1.34539 25.217 1.14803 26.8612 1 28.4555H4.15789L6.82237 14.5551C6.77303 11.0177 6.13158 7.58002 4.89803 4.24194C3.17105 7.28109 2.33224 15.5516 1.49342 23.5729Z"
        fill="currentColor"
      />
      <path
        d="M20.3914 2C17.4803 3.84342 14.5197 3.84342 11.6086 2L5.6875 3.44484C7.11842 7.18149 7.80921 11.1174 7.80921 15.153V28.2562C7.85855 29.0036 10.7204 30 16 30C21.2796 30 24.1415 29.0036 24.1415 28.306V15.2028C24.1415 11.1673 24.8322 7.23132 26.2632 3.49466L20.3914 2Z"
        fill="currentColor"
      />
      <path
        d="M31 28.4056C30.8026 26.8113 30.6546 25.1672 30.5066 23.5231C29.6678 15.5516 28.8289 7.28109 27.1513 4.24194C25.9671 7.5302 25.3257 11.0177 25.227 14.5551L27.8914 28.4555H31V28.4056Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
